.reveal {
  opacity: 0;
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.fade {
  transform: translateY(0);
}

.fade.visible {
  opacity: 1;
}

.slide-bottom {
  transform: translateY(30px);
}

.slide-bottom.visible {
  opacity: 1;
  transform: translateY(0);
}

.slide-right {
  transform: translateX(30px);
}

.slide-right.visible {
  opacity: 1;
  transform: translateX(0);
}

.slide-left {
  transform: translateX(-30px);
}

.slide-left.visible {
  opacity: 1;
  transform: translateX(0);
}

.zoom {
  transform: scale(0.8);
}

.zoom.visible {
  opacity: 1;
  transform: scale(1);
}

@keyframes spring {
  0% { transform: scale(0.8); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.spring.visible {
  opacity: 1;
  animation: spring 0.6s ease-out;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.bounce.visible {
  opacity: 1;
  animation: bounce 0.6s ease-in-out infinite;
}

/* 
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.spin.visible {
  opacity: 1;
  animation: spin 1s linear infinite;
} */

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.pulse.visible {
  opacity: 1;
  animation: pulse 1.2s ease-in-out infinite;
}
